$(document).on('change', '#relation-company-details input[name="relatable_id"]', function () {
    let companyDetailsWrapper = $(document).find('#relation-company-details')
    let value = $(this).val() ?? '';
    if (value.length < 1) {
        return;
    }

    $.get(companyDetailsWrapper.data('department-route').replace(/\/\d+\//gi, '/' + value + '/'), null, (result) => {
        let departmentInput = companyDetailsWrapper.find('#department_id');
        departmentInput.html(result);
        departmentInput.attr('disabled', departmentInput.find('option').length < 2);
    })
});
